import { useEffect, useState } from 'react';
import screenfull from 'screenfull';

function usePresentationMode() {
    const [isPresentationMode, setIsPresentationMode] = useState(false);

    useEffect(() => {
        function handleFullscreenChange() {
            if (screenfull.isEnabled) {
                setIsPresentationMode(screenfull.isFullscreen);
            }
        }
        if (screenfull.isEnabled) {
            window.addEventListener(screenfull.raw.fullscreenchange, handleFullscreenChange);
        }
        return () => {
            if (screenfull.isEnabled) {
                window.removeEventListener(screenfull.raw.fullscreenchange, handleFullscreenChange);
            }
        };
    }, [setIsPresentationMode]);

    function handleMinimize() {
        if (screenfull.isEnabled) {
            screenfull.exit();
        }
        setIsPresentationMode(false);
    }

    function handleMaximize() {
        if (screenfull.isEnabled) {
            screenfull.request();
        }
        setIsPresentationMode(true);
    }

    return {
        handleMaximize,
        handleMinimize,
        isPresentationMode,
    };
}

export default usePresentationMode;
